// API client — conecta al backend Express
// Incluye el Firebase ID token en cada request automáticamente

import { auth } from './firebase'

const API_BASE_URL = '/api'

async function getToken() {
  const user = auth.currentUser
  if (!user) return null
  return user.getIdToken()
}

async function authHeaders() {
  const token = await getToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

function buildUrl(endpoint) {
  if (endpoint.startsWith('/api')) return endpoint
  return `${API_BASE_URL}${endpoint}`
}

export const api = {
  baseUrl: API_BASE_URL,

  async get(endpoint, params = {}) {
    const path = buildUrl(endpoint)
    const url = new URL(path, window.location.origin)
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null) url.searchParams.append(k, v)
    })
    const headers = await authHeaders()
    const res = await fetch(url.toString(), { headers })
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: res.statusText }))
      throw new Error(err.message || `Error ${res.status}`)
    }
    return res.json()
  },

  async post(endpoint, body) {
    const headers = { 'Content-Type': 'application/json', ...(await authHeaders()) }
    const res = await fetch(buildUrl(endpoint), {
      method: 'POST',
      headers,
      body: JSON.stringify(body)
    })
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: res.statusText }))
      throw new Error(err.message || `Error ${res.status}`)
    }
    return res.json()
  },

  async upload(endpoint, formData) {
    const headers = await authHeaders()
    const res = await fetch(buildUrl(endpoint), { method: 'POST', headers, body: formData })
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: res.statusText }))
      throw new Error(err.message || `Error ${res.status}`)
    }
    return res.json()
  },

  async download(endpoint, filename) {
    const headers = await authHeaders()
    const res = await fetch(buildUrl(endpoint), { headers })
    if (!res.ok) {
      const err = await res.json().catch(() => ({ message: res.statusText }))
      throw new Error(err.message || `Error ${res.status}`)
    }
    const blob = await res.blob()
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename || (res.headers.get('Content-Disposition') || '').replace(/.*filename="?([^";]+)"?.*/, '$1') || 'export.csv'
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
  }
}

export const supabase = null
